import React from 'react'
import styled from 'styled-components'
import {
  ButtonGroup,
  Button,
  Row,
  Label,
  Col,
} from 'reactstrap'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import moment from '../../../../lib/moment.js'
import { statusColor } from '../../helpers/color'
import * as CONSTANTS from '../../constants'
import { FONTS } from '../../../../constants'

export default class RemarkRow extends React.Component {
  state={ hide: false }
  hideInfo = (e) => {
    this.setState({
      hide: e,
    })
  }
  render() {
    const users = get(this.props, 'timesheets.users', [])
    const timesheetStatus = get(this.props, 'timesheetRequest.timesheetRequest.status')
    const approve_status = get(this.props, 'timesheetRequest.timesheetRequest.approve_status', [])

    return (
      <RemarkTab>
        <Wrapper>
          <TextLabel>Remarks</TextLabel>
          <ButtonGroup>
            <Btn
              onClick={ () => this.hideInfo(true) }
              showhide={ this.state.hide ? 'true' : 'false' }
            >
              Hide
            </Btn>
            <Btn
              onClick={ () => this.hideInfo(false) }
              showhide={ !this.state.hide ? 'true' : 'false' }
            >
              Show
            </Btn>
          </ButtonGroup>
        </Wrapper>
        {
          approve_status.map((status) => {
            const approve = find(users, { _id: status.approver_id })
            return (
              <RemarkBox key={ shortid() } style={ { display: this.state.hide ? 'none' : 'flex' } }>
                <RemarkContent>
                  <Col>
                    <Row>
                      <NameLabel>{ approve ? `${get(approve, 'first_name')} ${get(approve, 'last_name')} (${get(approve, 'nick_name')})` : '-'}</NameLabel>
                      <InfoLabel color={ statusColor(status.status) }>
                        <Circle color={ statusColor(status.status) } />
                        {
                          timesheetStatus === CONSTANTS.REJECTED
                          && status.status === CONSTANTS.PENDING ?
                            CONSTANTS.POSTPONE : status.status
                        }
                      </InfoLabel>
                      <InfoLabel>{ status.submitted && moment(status.submitted).format('DD/MM/YYYY') }</InfoLabel>
                    </Row>
                    <Row>
                      <InfoLabel>{ status.remark !== '' ? status.remark : '-' }</InfoLabel>
                    </Row>
                  </Col>
                </RemarkContent>
              </RemarkBox>
            )
          }
          )
        }
      </RemarkTab>
    )
  }
}

const Wrapper = styled.div`
  background-color: #FFFFFF ;
  height: 40px;
  width: 100%;
  flex-direction: row;
  flex: 1;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #EEEEEE;
  padding-left: 10px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
`
const RemarkTab = styled.div`
  background-color: #EEEEEE ;
  flex-direction: column;
  flex: 1;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #EEEEEE;
  display: flex;
  align-items: center;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const RemarkBox = styled.div`
  background-color: #EEEEEE ;
  border-radius: 5px;
  height: 50px;
  width: 100%;
  padding-left: 10px ;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`
const RemarkContent = styled.div`
  background-color: #FFFFFF ;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  height: 50px;
  width: 70%;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`
const TextLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin-right: 15px;
  margin-bottom: 0px !important;
`
const NameLabel = styled(Label)`
  display: flex;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom:0px !important;
  margin-left: 30px;
  color: ${props => { return props.color ? props.color : 'black' }};
`
const InfoLabel = styled(NameLabel)`
  font-family: ${FONTS.GOTHAM} !important;
`
const Btn = styled(Button)`
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #AD2624;
  font-family: ${props => {
    return props.showhide === 'true' ? `${FONTS.GOTHAM_MEDIUM}` : `${FONTS.GOTHAM}`
  }};
  background-color: ${props => {
    return props.showhide === 'true' ? '#D44B49' : '#FFFFFF'
  }};
  color: ${props => {
    return props.showhide === 'true' ? '#FFFFFF' : '#AD2624'
  }};
  &:hover {
    background-color: ${props => {
    return props.showhide === 'true' ? '#D44B49' : '#FFFFFF'
  }};
  color: ${props => {
    return props.showhide === 'true' ? '#FFFFFF' : '#AD2624'
  }};
  }
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/remark-row.js